module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"title":"Lisää liitteitä"},"en":{"title":"Add attachments"}}')
  delete Component.options._Ctor
}
